// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueI18n from 'vue-i18n';
import App from './App'
import router from './router'
import Axios from './assets/js/axios'
import * as CONSTANS from './assets/js/Constants'
import filters from './assets/js/DataFilter'
import vueFilters from './assets/js/VueFilter'
import store from "./store"
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/base.css';
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition';
import locale from 'element-ui/lib/locale/lang/en'
import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/base.css' /*引入公共样式*/
import './assets/css/main.css' /*引入公共样式*/
import './assets/font/iconfont.css'
import JsEncrypt from 'jsencrypt'
import 'babel-polyfill'
import {RETURN_URL,LOGIN_URL,IS_YH,IS_NMG,IS_RC} from "./config/index";

// import '../theme/index.css'  //融创主题色
import '../theme_yh/index.css'  //粤海主题色

Vue.use(VueI18n);
const i18n = new VueI18n({
	locale:localStorage.lang || 'zh',
	messages: {
		'zh':require('./common/lang/zh'),
		'en':require('./common/lang/en')
	}
});

Vue.use(ElementUI);
Vue.component(CollapseTransition)
Vue.prototype.$jsEncrypt = JsEncrypt;
Vue.config.productionTip = false;
Vue.prototype.$http = Axios;
Vue.prototype.C = CONSTANS;

Vue.prototype.$ReturnUrl = RETURN_URL;
Vue.prototype.$LoginUrl = LOGIN_URL;
Vue.prototype.$isYH = IS_YH;
Vue.prototype.$isNMG = IS_NMG;
Vue.prototype.$isRC = IS_RC;

for (var k in filters) {
	Vue.filter(k, filters[k])
}

Vue.prototype.$token = {
	headers: {
		'accessToken': localStorage.accessToken,
		'userToken': localStorage.userToken,
	}
};

//融创百度统计
var _hmt = _hmt || [];
window._hmt = _hmt;
(function () {
	var hm = document.createElement("script");
	hm.src = "https://hm.baidu.com/hm.js?ebbe9069a11c96701e8a5b7802849511";
	var s = document.getElementsByTagName("script")[0];
	s.parentNode.insertBefore(hm, s);
})();



/* eslint-disable no-new */
new Vue({
	el: '#app',
	i18n,
	router,
	store,
	template: '<App/>',
	components: {App}
});








// WEBPACK FOOTER //
// ./src/main.js